import Vue from 'vue';
import Vuex from 'vuex';

Vue.use (Vuex);

export default new Vuex.Store ({
  state: {
    isLogin: localStorage.getItem ('X-Access-Token') ? true : false,
  },
  mutations: {
    getIslogin (state, data) {
      state.isLogin = data;
    },
  },
});
// 15820496034


// WEBPACK FOOTER //
// ./src/store/index.js